import { render, staticRenderFns } from "./ConferenceSimpleInfoView.vue?vue&type=template&id=0a69c43f&scoped=true&"
import script from "./ConferenceSimpleInfoView.vue?vue&type=script&lang=js&"
export * from "./ConferenceSimpleInfoView.vue?vue&type=script&lang=js&"
import style0 from "./ConferenceSimpleInfoView.vue?vue&type=style&index=0&id=0a69c43f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a69c43f",
  null
  
)

export default component.exports